/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.4.1 public/assets/models/masks/mask-eyes-01.glb 
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import useCharacterMaterials from "hooks/useCharacterMaterials";
import useCharacterMorphs from "hooks/useCharacterMorphs";
import {PUBLIC_URL} from "helpers/app";

export function MaskEyes01(props) {
  const { nodes, materials } = useGLTF(PUBLIC_URL + '/assets/models/masks/mask-eyes-01.glb');
  const characterMaterials = useCharacterMaterials(materials);
  useCharacterMorphs(nodes);

  return (
    <group {...props} dispose={null}>
      <mesh name="MaskEyes01" geometry={nodes.MaskEyes01.geometry} material={characterMaterials.MaskPrimary} morphTargetDictionary={nodes.MaskEyes01.morphTargetDictionary} morphTargetInfluences={nodes.MaskEyes01.morphTargetInfluences} position={[0, 1.289, -0.098]} rotation={[0.047, 0, 0]} scale={0.922} />
    </group>
  )
}

//useGLTF.preload(PUBLIC_URL + '/assets/models/masks/mask-eyes-01.glb')
